import { render } from "./InventorySummary.vue?vue&type=template&id=e8663d26&scoped=true"
import script from "./InventorySummary.vue?vue&type=script&lang=js"
export * from "./InventorySummary.vue?vue&type=script&lang=js"

import "./InventorySummary.vue?vue&type=style&index=0&id=e8663d26&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8663d26"]])

export default __exports__